module.exports = require("core-js-pure/features/array/from");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/array/from.js
// module id = 341
// module chunks = 0